export default __webpack_public_path__ + "fonts/HelveticaNeueLT-Roman.eot";